import { AbstractBaseComponent } from './AbstractBaseComponent';
import { SelectDTO } from './newModel';

export abstract class AbstractListComponent extends AbstractBaseComponent {
  public idVaiA: string;
  public vaiAList: SelectDTO[];

  abstract goToPage(idVaiA: string, event: any);
  abstract nextPage(skip: number, take: number, count: number, offset?: number);
  abstract previousPage(skip: number, take: number, offset?: number);

  goToPageEmitter(event: any) {
    this.goToPage(event.idVaiA, event.event);
  }

  nextPageEmitter(event: any) {
    this.nextPage(event.skip, event.take, event.count, event.offset);
  }

  previousPageEmitter(event: any) {
    this.previousPage(event.skip, event.take, event.offset);
  }

  calcolaListVaiA(maxLength: number) {
    this.vaiAList = [];
    this.idVaiA = '';
    for (let index = 1; index <= maxLength; index++) {
      const currentSelect = new SelectDTO();
      currentSelect.value = '' + (index - 1);
      currentSelect.viewValue = '' + index;
      this.vaiAList.push(currentSelect);
    }
  }
}
